module.exports = __webpack_public_path__ + "img/empty.4bcd8ecf.svg";